<template>
<div class="login" :class="{mobile:!isPc}">
    <div class="container">
        <div class="btns">
            <span>Thumbnail</span>
            <span>Video</span>
        </div>
        <div class="downLogo" v-if="$route.name == 'home'">

<!--            <img src="http://weddingimg-oss.tvunetworks.cn/weddinglive-image/20190730/e6d9007f436b44479c5c48f23820b9e7.png" alt="">-->
            <img src="../assets/img/logo.png" alt="">
            <a class="colorccc" @click="signIn">Sign In</a>
        </div>
        <div class="videos">
            <ul class="clearfix">
                <li v-for="(val,key) in videoList" :key="key">
                    <div class="video">
                        <!-- <video id="video1" controls type="video/mp4" autoplay muted loop>
                            <source src="../assets/video/CNN sample stream 1.mp4" type="video/mp4">
                        </video> -->
                        <!-- class="video-js vjs-default-skin vjs-big-play-centered"  -->
                            
                            <video
                                :id="val.key"
                                preload="auto"
                                ref="videoPlayer"
                                type="video/mp4"
                                muted
                                loop
                                controls
                                :poster="val.poster"
                                class="video-js vjs-default-skin vjs-big-play-centered clearfix" 
                                x-webkit-airplay="allow" 	
                                webkit-playsinline playsinline x5-video-player-type="h5"
                                >
                            </video>
                        <div class="mateData">
                            {{val.mateData}}
                        </div>
                    </div>
                    <div class="info clearfix">
                        <div>
                            <div class="f_l green">{{val.sourceName}}</div>
                            <div class="f_r">
                                <!-- <span class="gray mobile-none">Live Time (This Month): <span class="red">10:21:56</span></span> -->
                                <el-checkbox v-model="checked">Show metadata</el-checkbox>
                            </div>
                        </div>
                        <div class="mobile">
                            <!-- <div class="f_l"><span class="gray">Live Time (This Month): <span class="red">10:21:56</span></span></div> -->
                            <div class="f_r">
                                <!-- <span class="gray">Error:1%</span> -->
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <router-view></router-view>
    <div class="operate-btns" v-if="$route.name == 'home' || $store.state.showShare">
        <div class="btns">
            <i class="iconfont icon-share share-btn" @click="shareFn"></i>
            <a :href="downLoadAppUrl" download="GridLink" @click="app()" v-if="!hideBtn">
                <img src="../assets/img/Appstore.png"/>
            </a>
            <a :href="downLoadAndroidUrl" download="GridLink" @click="app()"  v-if="!hideBtn">
                <img src="../assets/img/android.png"/>
            </a>
<!--            <img class="el-icon-share" src="../assets/img/share.png" @click="shareFn"/>-->
            <img class="el-icon-concat" src="../assets/img/Contact.png" @click="showContactUs = true;"/>
            <div class="contact-us" v-if="showContactUs">
                <div class="title clearfix">
                    <span>Contact us</span>
                    <i class="el-icon-close" @click="showContactUs = false;"></i>
                </div>
                <div class="content">If you need more information regarding how to receive these TVU Grid feeds on a TVU receiver or have any other questions about TVU GridLink, please contact us at
                    <a href="mailto:GridLinkSupport@tvunetworks.com" target="_blank">GridLinkSupport@tvunetworks.com</a>
                </div>
            </div>
        </div>
        
    </div>
    <account-share :info="share" v-if="share.show"></account-share>
</div>
</template>
<script>
// import 'videojs-contrib-hls';
import { gaAnalyze } from '@/assets/js/googleAnalyze/event.js';
import 'video.js/dist/video-js.css';
import videojs from 'video.js';
import AccountShare from './account/share';
export default {
    data(){
        return{
            checked:true,
            videoList:[
                {
                    key:'vid1',
                    url:require('@/assets/video/CNNsamplestream1.mp4'),
                    mateData:'VP Pence attends Young America’s Foundation 41st Annual National Conservative Student Conference to deliver remarks to more than 500 students.',
                    sourceName:'Feed1_SDI',
                    poster:require('@/assets/img/video1.png'),
                },
                {
                    key:'vid2',
                    url:require('@/assets/video/CNNsamplevideo2.mp4'),
                    mateData:'Pete Buttigieg speaks with union workers in Detroit, MI',
                    sourceName:'Feed2_SDI',
                    poster:require('@/assets/img/video2.png'),
                },
                {
                    key:'vid3',
                    url:require('@/assets/video/CNNsamplevideo3.mp4'),
                    mateData:'White House Bump Shot',
                    sourceName:'Feed3_SDI',
                    poster:require('@/assets/img/video3.png'),
                },
                {
                    key:'vid4',
                    url:require('@/assets/video/CNNsamplevideo4.mp4'),
                    mateData:'President Khaltmaagiin Battulga of Mongolia visits the White House',
                    sourceName:'Feed4_SDI',
                    poster:require('@/assets/img/video4.png'),
                },
            ],
            ifSafari:false,
            share:{
                show:false
            },
            isMac:false,
            isChina:false,
            downLoadAndroidUrl:'',
            downLoadAppUrl:'',
            showContactUs:false,
            cookie:1,
            hideBtn:false,
        }
    },
    components:{
        AccountShare
    },
    created(){
        
        this.isPc = this.isPC();
        let u = navigator.userAgent; //取得浏览器的userAgent字符串
        // console.log(userAgent);
        // alert(u);
        // let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
        let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if(isiOS) {
            this.ifSafari = true;
        }else{
            this.ifSafari = false;
        }

        this.isMac = /macintosh|mac os x/i.test(navigator.userAgent);

        // this.axios.get('http://api.ipstack.com/101.231.194.10?access_key=1cca9631cdf71d43f257038a937ac6a8').then(res=>{
        //     console.info(155,res);
        // })
        let language = navigator.language || navigator.userLanguage;
        this.isChina = language == 'zh-CN' ? true : false;

        // if(this.isPC()){
            if(this.isChina){
                this.downLoadAppUrl = 'https://apps.apple.com/cn/app/tvu-gridlink/id1316890292';
            }else{
                this.downLoadAppUrl = 'https://apps.apple.com/us/app/tvu-gridlink/id1316890292';
            }
            this.downLoadAndroidUrl = 'https://play.google.com/store/apps/details?id=com.tvunetworks.android.tvugridlink';
        // }else{
        //     if(this.isChina){
        //         this.downLoadAppUrl = 'https://apps.apple.com/cn/app/tvu-gridlink/id1316890292';
        //     }else{
        //         this.downLoadAppUrl = 'https://apps.apple.com/us/app/tvu-gridlink/id1316890292';
        //     }
        //     this.downLoadAndroidUrl = 'https://play.google.com/store/apps/details?id=com.tvunetworks.android.tvugridlink';
        // }
    },
    mounted(){
        var whdef = 100/window.innerWidth;// 表示1920的设计图,使用100PX的默认值
        var wW = window.innerWidth;// 当前窗口的宽度
        var rem = wW * whdef;// 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
        $('html').css('font-size', rem + "px");
        this.videoList.map(v=>{
            this.playVideoByVideojs(v);
        })
        // 在app内隐藏按钮
        let cookies = document.cookie.split(';')
        cookies.map(v=>{
            if(v.includes('appflag')){
                this.hideBtn = true;
            }
        })
    },
    methods:{
        playVideoByVideojs(obj) {
            // var _this = this;

            let player = videojs(obj.key, {
                bigPlayButton: false,
                textTrackDisplay: false,
                posterImage: true,
                errorDisplay: false,
                controlBar: true
            }, function onPlayerReady() {
                // videojs.log('播放器已经准备好了!');
                this.on('ready',function() {
                    this.play()
                })
                // this.on('loadstart',()=> {
                // console.log('loadstart------------')
                // });
                
                // this.on('progress',()=> {
                // console.log('progress-------加载过程----')
                // });
                // this.on('loadedmetadata',()=> {
                // console.log('loadedmetadata---视频源数据加载完成----')
                // });
                // this.on('play',()=> {
                // console.log('play-------play----')
                // });
                
            })
            const src = obj.url;
            player.src(src);
            player.load(src);
        },
        signIn(){
            gaAnalyze('lpStartSignIn');
            window.location.href = "https://" + window.location.host + '/userGroup/user-group/rgUser/redirectSignIn';
        },
        app(){
           gaAnalyze('lpStartIos'); 
        },
        shareFn(){
            gaAnalyze('lpShare'); 
            this.share.show = true;
        },
        isPC() {
            let userAgentInfo = navigator.userAgent;
            let Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
            let flag = true;
            for (let v = 0; v < Agents.length; v++) {
                if (userAgentInfo.indexOf(Agents[v]) > 0) { flag = false; break; }
            }
            return flag;
        },
        tipsApp(){
            this.$message({
                message: 'This app is currently only available for iOS devices.',
                type: 'error',
                customClass:'app-tips'
            })
        },
    }
}
</script>
<style lang="less">
@import '../assets/css/verticalScreen.less';
body{
    font-size: 0.14rem;
}
.container{
    margin: 0 auto;
    .btns{
        margin: 0.3rem 0;
        span{
            font-size: 0.12rem;
            color: #fff;
            border-radius: 3px;
            padding: 5px;
            background: #33AB4F;
            border: 1px solid #33AB4F;
            &:first-child{
                border: 1px solid #33AB4F;
                background: none;
                margin-right: 10px;
            }
        }
    }
    .mobile{
        display: none;
    }
    .colorccc{
        color: #ccc;
        position: fixed;
        top: .3rem;
        right: .2rem;
        z-index: 10;
        // margin-right: .2rem;
    }
    .width95{
        width: .95rem;
    }
    .downLogo{
        a{
            position: fixed;
            top: .31rem;
            right: 0.3rem;
            z-index: 3;
        }
        img{
            position: fixed;
            top: .24rem;
            left: 0.3rem;
            z-index: 3;
            display: block;
            width: .64rem;
        }
    }
}
.videos li{
    float: left;
    width: calc(50% - 10px);
    margin: 0 0.1rem 0.1rem 0;
    // height: 4.1rem;
    position: relative;
    .video{
        // height: 3.75rem;
        width: 100%;
        .video-js{
            width: 100%;
            height: auto;
        }
        .none{
            display: none;
        }
        .vjs-tech{
           position: relative; 
        }
        video{
            width: 100%;
            display: block;
        }
        .mateData{
            width: 80%;
            background:rgba(0,0,0,0.42);
            border-radius:4px;
            position: absolute;
            bottom: .5rem;
            left: 10%;
            color: #fff;
            font-size: 0.16rem;
            padding: 0.08rem;
            line-height: 0.2rem;
        }
    }
    .info{
        background: #08130A;
        height: .35rem;
        // position: absolute;
        // bottom: 0;
        width: 100%;
        line-height: .35rem;
        padding: 0 .24rem;
        
        .green{
            color: #33AB4F;
        }
        .red{
            color: #FF3300;
        }
        .gray{
            color: #999;
            margin-right: .15rem;
        }
        /deep/.el-checkbox__label{
            color: #fff;
        }
    }
    
}
.operate-btns{
    position: fixed;
    right: .2rem;
    bottom: .2rem;
    z-index: 10;
    display: inline-block;
    img{
        width: 1.02rem;
        display: block;
        margin-bottom: .12rem;
        cursor: pointer;
    }
    .btns{
        position: relative;
        .share-btn {
            color: #fff;
            font-size: .34rem;
            float: right;
            display: inline-block;
            margin-bottom: .12rem;
        }
    }
    .contact-us{
        width: 3.84rem;
        position: absolute;
        right: 0;
        bottom: .45rem;
        background: #fff;
        box-shadow:0px 4px 12px 0px rgba(0,0,0,0.15);
        border-radius:4px;
        padding: .18rem .24rem;
        .title{
            margin-bottom: .08rem;
            span{
                float: left;
                font-size: .18rem;
                font-weight: bold;
            }
            i{
                float: right;
                cursor: pointer;
            }
        }
        .content{
            font-size: .14rem;
            color: #000;
            line-height: .22rem;
            a{
                color: #1EC345;
            }
        }
    }
}
@media(min-width:1350px){
    .container{
        width: 1350px;
        .downLogos{
            display: none;
        }
    }
    .start{
        .content{
            width: 100%;
        }
    }
    .account{
        .content{
            width: 6.2rem;
            padding: 0.6rem;
        }
    }
    
}
@media screen and (min-width:1024px) and (max-width:1350px){
    .container{
        width: 1000px;
        .downLogos{
            display: none;
        }
    }
    .start{
        .content{
            width: 100%;
        }
    }
    .account{
        .content{
            width: 5.2rem;
            padding: 0.6rem;
        }
    }
    
}
@media screen and (min-width:760px) and (max-width:1023px){
    .container{
        width: 90%;
        .downLogos{
            display: none;
        }
    }
    .login{
        width: 100%;
        .videos{
            ul{
                padding: 0 .1rem;
            }
            li{
                width: 100%;
                // height: 2.5rem;
                .video-js{
                    height: auto;
                }
                .video{
                    .mateData{
                        width: 90%;
                        left: 5%;
                        bottom: .6rem;
                        font-size: .12rem;
                    }
                }
                .info{
                    background: #08130A;
                    // height: .55rem;
                    width: 100%;
                    line-height: .2rem;
                    padding: 0.05rem;
                    .green{
                        color: #33AB4F;
                    }
                    .red{
                        color: #FF3300;
                    }
                    .gray{
                        color: #999;
                        margin-right: 0 !important;
                    }
                    /deep/.el-checkbox__label{
                        color: #fff;
                    }
                }
                .mobile-none{
                    display: none;
                }
                .mobile{
                    display: block;
                }
            }
        }
        .btns{
            padding-left: .1rem;
        }
        .start{
            .content{
                width: 100%;
            }
        }
        .account{
            .content{
                padding: 0.3rem;
            }
        }
    }
    .operate-btns{
        position: fixed;
        left: 50%;
        margin-left: -2rem;
        display: inline-block;
        .btns{
            display: inline-block;
            .share-btn {
                margin-bottom: 0;
            }
        }
        img{
            display: inline-block;
            margin-right: .12rem;
            width: .92rem;
            margin-bottom: 0;

        }
        .contact-us{
            right: .12rem;
            bottom: .4rem;
            background: #fff;
        }
    }
}
@media(max-width:760px){
    .container{
        .downLogo{
            display: none;
        }
    }
    .login{
        width: 100%;
        .videos{
            ul{
                padding: 0 .1rem;
            }
            li{
                width: 100%;
                // height: 2.5rem;
                .video-js{
                    height: auto;
                }
                .video{
                    .mateData{
                        width: 90%;
                        left: 5%;
                        bottom: .6rem;
                        font-size: .12rem;
                    }
                }
                .info{
                    background: #08130A;
                    // height: .55rem;
                    width: 100%;
                    line-height: .2rem;
                    padding: 0.05rem;
                    .green{
                        color: #33AB4F;
                    }
                    .red{
                        color: #FF3300;
                    }
                    .gray{
                        color: #999;
                        margin-right: 0 !important;
                    }
                    /deep/.el-checkbox__label{
                        color: #fff;
                    }
                }
                .mobile-none{
                    display: none;
                }
                .mobile{
                    display: block;
                }
            }
        }
        .btns{
            padding-left: .1rem;
        }
        .start{
            .content{
                width: 100%;
            }
        }
        .account{
            .content{
                width: 90%;
                padding: 0.3rem;
            }
        }
    }
    .operate-btns{
        position: fixed;
        left: 0;
        width: 100vw;
        text-align: center;
        .btns{
            display: inline-block;
            .share-btn {
                margin-bottom: 0;
                font-size: .24rem;
            }
        }
        img{
            display: inline-block;
            margin-right: .12rem;
            width: .68rem;
            margin-bottom: 0;

        }
        .contact-us{
            width: 80vw;
            position: fixed;
            left: 50%;
            transform: translateX(-50%);
            bottom: .55rem;
            background: #fff;
            text-align: left;
            .content{
                font-size: .14rem;
            }
        }
    } 
}
</style>

